// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../wizard/WizardFormUtils.bs.js");
let Form__Validators = require("../../../reason/common/Form/Form__Validators.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardFormValidation = require("../wizard/WizardFormValidation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let WizardDisplayNeighborhoodValidation = require("../wizard/WizardDisplayNeighborhoodValidation.bs.js");
let PropertyWizardFormRelayValidatorsDescription_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescription_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescription_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescription_formState_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useIsValid(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, draft);
  return Stdlib_Option.getOr(WizardFormValidation.requiredStringWithMaxLength(150, maxLength => "Longer than " + (maxLength.toString() + " characters! Keep this field short and concise"), draft$1.subject), {
    NAME: "Error",
    VAL: "is required"
  });
}

let Subject = {
  DraftFragment: DraftFragment,
  subjectLengthLimit: 150,
  useIsValid: useIsValid
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid$1(draft) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, draft);
  let tmp = match.mode;
  if (typeof tmp !== "object") {
    return "Valid";
  }
  if (tmp.TAG !== "Rebroadcast") {
    return "Valid";
  }
  let match$1 = WizardFormUtils.noneIfEmpty(draft$1.message);
  if (match$1 !== undefined) {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let Message = {
  DraftFragment: DraftFragment$1,
  useIsValid: useIsValid$1
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useIsValid$2(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, draft);
  let agent = UserSession.useAgentInfo();
  let personalInfoValidationFlag = FeaturesV3.useFeatureFlipper("ValidatePersonalInfoInDescription");
  let personalInfoValidationEnabled = personalInfoValidationFlag === "on";
  let match = WizardFormUtils.noneIfEmpty(draft$1.draftProperty.description);
  if (match === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  if (!personalInfoValidationEnabled) {
    return "Valid";
  }
  let match$1 = agent.membership.account.owner;
  if (match$1 === undefined) {
    return {
      NAME: "Error",
      VAL: ""
    };
  }
  let owner = match$1.agent;
  let str = Form__Validators.PersonalInfoValidation.validate({
    id: agent.id,
    firstName: agent.firstName,
    lastName: agent.lastName,
    displayName: agent.displayName
  }, {
    id: owner.id,
    firstName: owner.firstName,
    lastName: owner.lastName,
    displayName: owner.displayName
  }, match);
  if (str.TAG === "Ok") {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "Personal or contact information should only be in the \"Message to TAN colleagues\" field below." + Stdlib_Option.getOr(Stdlib_Option.map(str._0, m => ` Please remove "` + m + `" from the description.`), "")
    };
  }
}

let Description = {
  DraftFragment: DraftFragment$2,
  useIsValid: useIsValid$2
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

let DraftFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

let convertFragment$4 = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

let FormStateFragment_localGeocodingStatus_decode = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Utils.localGeocodingStatus_decode;

let FormStateFragment_localGeocodingStatus_fromString = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Utils.localGeocodingStatus_fromString;

let FormStateFragment = {
  localGeocodingStatus_decode: FormStateFragment_localGeocodingStatus_decode,
  localGeocodingStatus_fromString: FormStateFragment_localGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function useIsValid$3(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, formState);
  return WizardDisplayNeighborhoodValidation.useIsValid(draft$1.draftProperty.address, draft$1.draftProperty.selectedArea, draft$1.draftProperty.displayNeighborhood, formState$1.displayNeighborhoods, formState$1.geocodingStatus);
}

let DisplayNeighborhood = {
  DraftFragment: DraftFragment$3,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid$3
};

let convertFragment$5 = PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

let DraftFragment$4 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function useIsValid$4(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, draft);
  return WizardFormValidation.optionalValidatedString(Scalars.URL.fromString, param => "Please enter a valid URL", draft$1.draftProperty.website);
}

let Website = {
  DraftFragment: DraftFragment$4,
  useIsValid: useIsValid$4
};

let convertFragment$6 = PropertyWizardFormRelayValidatorsDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

let DraftFragment$5 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

let convertFragment$7 = PropertyWizardFormRelayValidatorsDescription_formState_graphql.Internal.convertFragment;

function waitForFragmentData$7(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7);
}

function readResolverFragment$7(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

let FormStateFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$7,
  waitForFragmentData: waitForFragmentData$7,
  use: use$7,
  useOpt: useOpt$7,
  readResolverFragment: readResolverFragment$7
};

function use$8(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, formState);
  let subjectIsValid = useIsValid(draft$1.fragmentRefs);
  let displayNeighborhoodIsValid = useIsValid$3(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let descriptionIsValid = useIsValid$2(draft$1.fragmentRefs);
  let messageIsValid = useIsValid$1(draft$1.fragmentRefs);
  let websiteIsValid = useIsValid$4(draft$1.fragmentRefs);
  return WizardFormValidation.allValid([
    subjectIsValid,
    displayNeighborhoodIsValid,
    descriptionIsValid,
    messageIsValid,
    websiteIsValid
  ]);
}

let FormUtils;

exports.FormUtils = FormUtils;
exports.Subject = Subject;
exports.Message = Message;
exports.Description = Description;
exports.DisplayNeighborhood = DisplayNeighborhood;
exports.Website = Website;
exports.DraftFragment = DraftFragment$5;
exports.FormStateFragment = FormStateFragment$1;
exports.use = use$8;
/* Scalars Not a pure module */
